import { SurveyQuestionsForm } from 'store/states/lessons.state'
import { QuestionTypeEnum } from 'enum'
import Likert from './components/LikertForm/Likert'
import OpenEnded from './components/OpenEnded/OpenEnded'

interface SurveyProps {
  id: number
  questionList: SurveyQuestionsForm[]
  canEdit: boolean
  refArray: any
  count: any
  lessonIndex: number
}

export const Survey = ({
  id,
  questionList,
  canEdit,
  refArray,
  count,
  lessonIndex,
}: SurveyProps) => {
  return (
    <>
      {questionList.map((question, index) => {
        if (question.questionableType === QuestionTypeEnum.likert) {
          return (
            <Likert
              canEdit={canEdit}
              key={'BlockSurvey/' + question.id + '-' + index}
              instanceId={id}
              data={question}
              refArray={(el: any) => {
                if (question.mandatory) {
                  refArray.current[count.current] = el
                  count.current++
                }
              }}
              lessonIndex={lessonIndex}
              questionIndex={index}
            />
          )
        } else {
          return (
            <OpenEnded
              key={'BlockSurvey/' + question.id + '-' + index}
              canEdit={canEdit}
              instanceId={id}
              data={question}
              refArray={(el: any) => {
                if (question.mandatory) {
                  refArray.current[count.current] = el
                  count.current++
                }
              }}
              lessonIndex={lessonIndex}
              questionIndex={index}
            />
          )
        }
      })}
    </>
  )
}
